export default __webpack_public_path__ + "static/media/FFF-QUICK.79de360f.png";